<div class="container">
  <div class="row d-print-none">
    <app-product-nav class="col-6 col-md-1 order-md-1" [direction]="'left'"></app-product-nav>
    <app-product-nav class="col-6 col-md-1 order-md-3" [direction]="'right'"></app-product-nav>
    <div *ngIf="productId$ | async as productId" class="d-flex justify-content-center mb-4">
      <ng-container *ngIf="favoriteProduct$ | async; else addFavoriteProduct">
        <button class="infoButton active" (click)="deleteFavoriteProduct(productId)">Favorit entfernen</button>
      </ng-container>
      <ng-template #addFavoriteProduct>
        <button class="infoButton" (click)="setFavoriteProduct(productId)">Favorit hinzufügen</button>
      </ng-template>
    </div>
    <div class="central col-12 col-md-10 order-md-2">
      <ng-container *ngIf="productId$ | async as productId">
        <ng-container *ngIf="cycleId$ | async as cycleId">
          <div class="thumbs" *ngIf="hasVotingPermissions">
            <button
              *ngFor="let vote of [vote$ | async]"
              class="votebutton"
              (click)="toggleVote(cycleId, productId, vote ? vote.verdict : 0)"
              [class.selected]="vote?.verdict === 1"
            >
              <i class="far fa-2x fa-thumbs-up" [class.fas]="vote?.verdict === 1"></i>
              <br />
              <div class="small-button-text">
                <div>Pitch gewünscht</div>
              </div>
            </button>
          </div>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="product$ | async as p">
        <app-ampel [startupId]="p.startupId"></app-ampel>
      </ng-container>
    </div>
  </div>
</div>

<ng-container *ngFor="let productId of productId$ | async | singleton">
  <app-product-view [productId]="productId">
    <div class="product-view-sub-contact request-sample d-print-none">
      <app-order-sample-button [productId]="productId"></app-order-sample-button>
    </div>
  </app-product-view>
</ng-container>
